import { createFileRoute } from '@tanstack/react-router';

import { getCompanyFinancialsQueryOptions } from '@/_pages/companies/api-service';
import Loading from '@/_pages/companies/financials/loading';

export const Route = createFileRoute('/_private/companies/_template/$id/financials')({
  loader: (opts) => opts.context.queryClient.ensureQueryData(getCompanyFinancialsQueryOptions(opts.params.id)),
  staticData: {
    pageTitle: 'Financials',
    tabKey: 'client/financials',
  },
  pendingComponent: Loading,
});
